<template>
  <div class="container banners-container" v-if="banners.length">
    <div
      v-for="banner in banners"
      :key="banner.key"
      class="banner"
      :class="className(banner.status)"
      >
      <div class="banner__icon">
        <BaseIcon :name="banner.status === 'info' ? 'warning' : banner.status"/>
      </div>
      <div class="banner__content">
        <h1 class="content__title">{{ banner.title }}</h1>
        <p class="content__message" v-html="banner.message"></p>
        <BaseButton @click.native="banner.buttonAction" v-if="banner.buttonAction" class="content__button" :title="banner.buttonLabel"/>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters('banners', [
        'banners'
      ])
    },
    methods: {
      className (status) {
        return {
          [`banner--${status}`]: status
        }
      }
    },
  }
</script>

<style lang="scss">
  @import './src/assets/styles/colors.scss';
  @import './src/assets/styles/breakpoints.scss';
  @import './src/assets/styles/grid.scss';
  
  .banners-container.container {
    margin-top: 30px;
    margin-bottom: 50px;
  }

  .banner {
    display: flex;
    align-items: flex-start;
    width: 100%;
    padding: 16px 16px 4px;
    box-shadow: 0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15);

    *:not(:last-of-type) {
      margin-bottom: 12px;
    }

    @include media(ltMobile) {
      margin-left: -$container-gutter-mobile;
      width: calc(100% + #{$container-gutter-mobile} * 2);
    }

    &__icon {
      flex-shrink: 0;
      width: 28px;
      height: 28px;
      padding: 4px;
      border-radius: 50%;
      margin-right: 16px;
      
      svg {
        width: 100%;
        height: 100%;
      }
    }
    
    &__content {
      margin-bottom: 12px;

      .content__title {
        font-size: 17px;
        font-weight: 600;
        line-height: 1.5;
      }

      .content__message {
        margin-top: 4px;
        font-size: 14.6px;
        line-height: 1.43;
      }

      .content__button {
        margin-top: 15px;
      }
    }

    &--warning {
      background-color: $color-old-lace;
      border-top: 3px solid $color-corn;

      .banner__icon {
        background-color: $color-salomie;

        svg {
          color: $color-reef-gold;
        }
      }
    }

    &--info {
      background-color: $color-placebo-sky;
      border-top: 3px solid $color-altdorf-sky-blue;

      .banner__icon {
        background-color: $color-continental-waters;

        svg {
          color: $color-altdorf-sky-blue;
        }
      }
    }

    &--success {
      background-color: #eff7ed;
      border-top: 3px solid #50b83c;

      .banner__icon {
        background-color: #bbe5b3;

        svg {
          color: #108043;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Banner.vue